import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { customApp } from '../_configuration/configuration';
import { TicketcodeAuthService } from '../_services/_auth/ticketcode-auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private ticketcodeAuthService: TicketcodeAuthService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    if (req.url.includes(customApp.url)) {
      const authToken = this.ticketcodeAuthService.getToken();
      const authRequest = req.clone({
        headers: req.headers.set('Authorization', 'Bearer ' + authToken)
      });

      return next.handle(authRequest);
    }
    return next.handle(req);
  }
}
